export default function FileSearch() {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g id="file-search">
                <path
                    id="Icon"
                    d="M11.6654 9.16667H6.66536M8.33203 12.5H6.66536M13.332 5.83334H6.66536M16.6654 8.75001V5.66667C16.6654 4.26654 16.6654 3.56647 16.3929 3.0317C16.1532 2.56129 15.7707 2.17884 15.3003 1.93916C14.7656 1.66667 14.0655 1.66667 12.6654 1.66667H7.33203C5.9319 1.66667 5.23183 1.66667 4.69706 1.93916C4.22665 2.17884 3.8442 2.56129 3.60451 3.0317C3.33203 3.56647 3.33203 4.26654 3.33203 5.66667V14.3333C3.33203 15.7335 3.33203 16.4335 3.60451 16.9683C3.8442 17.4387 4.22665 17.8212 4.69706 18.0609C5.23183 18.3333 5.9319 18.3333 7.33203 18.3333H9.58203M18.332 18.3333L17.082 17.0833M17.9154 15C17.9154 16.6108 16.6095 17.9167 14.9987 17.9167C13.3879 17.9167 12.082 16.6108 12.082 15C12.082 13.3892 13.3879 12.0833 14.9987 12.0833C16.6095 12.0833 17.9154 13.3892 17.9154 15Z"
                    stroke="currentColor"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
        </svg>
    );
}
